import type React from 'react';
import { useState } from 'react';

interface GuestNameViewProps {
  meetingId: string;
  onGuestJoin: (guestName: string) => void;
  onBack: () => void;
}

export const GuestNameView: React.FC<GuestNameViewProps> = ({ meetingId, onGuestJoin, onBack }) => {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed) {
      onGuestJoin(trimmed);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h1 id="sign-in-required-title" className="sign-in-required__title">
        Continue as guest
      </h1>
      <p className="sign-in-required__meeting-id">Meeting ID: {meetingId}</p>
      <p className="sign-in-required__description">Enter your name to continue as guest.</p>
      <div className="sign-in-required__input-group">
        <label htmlFor="guest-name" className="sign-in-required__label">
          Your name
        </label>
        <input
          id="guest-name"
          type="text"
          className="sign-in-required__input"
          placeholder="Enter your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="sign-in-required__actions">
        <button
          type="submit"
          disabled={!name.trim()}
          className="sign-in-required__button sign-in-required__button--primary"
        >
          Continue as Guest
        </button>
        <button
          type="button"
          onClick={onBack}
          className="sign-in-required__button sign-in-required__button--text"
        >
          Back
        </button>
      </div>
    </form>
  );
};
